import React from 'react';
import { withRouter } from 'react-router-dom';
import { api_route, user_logout } from '../helpers/Global';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import queryString from 'query-string';

class ReplyMessageLivreur extends React.Component {

    
    constructor(props) {
        super(props);
        var inputs = {};
        this.state = {
            titlepage: "Répondre à un message",
            inputs: inputs,
            liste_cities: [],
            liste_pages: [],
        }
    }

    submit = () => {
        const inputs = this.state.inputs;
        let formData = new FormData();
        const current_time = this.props.current_time;
        var keysinputs = Object.keys(inputs);
        keysinputs.forEach(function(element,keyelemnt){
            formData.append(element, inputs[element]);
        
        });
        
        fetch(api_route('save-reply-message'), { method: 'POST', body: formData })
            .then(resp => resp.json())
            .then(resp => {
                if (resp.response === 'error-connected') {
                    user_logout();
                    this.props.history.push(`/user-logout`);
                }
                if (resp.response === 'error') {
                    alertify.error(resp.message);
                } else if (resp.response === 'success') {
                    var inputs = {};
                    this.setState({ inputs: inputs }, function () {
                        alertify.success(resp.message);
                        this.props.setCurrentPage('');
                        this.props.history.push("/colis/list?fixedkeyword="+resp.barecode+"&t="+current_time);
                    });
                }
            })
           .catch(err => {
                this.props.loaderDisplay(false);
                this.props.openErrorSystem(true);
            })
    }
    
    componentDidMount() {
        
        window.scrollTo(0, 0);
        var params = queryString.parse(this.props.location.search);
        var message_id = params.message_id;
        
        if(message_id){
            this.props.loaderDisplay(true);
            
            fetch(api_route('infos-message') + '&message_id=' + message_id, { method: 'GET' })
            .then(resp => resp.json())
            .then(resp => {
                if (resp.response === 'error-connected') {
                    user_logout();
                    this.props.history.push(`/user-logout`);
                } else if (resp['info_message']) {
                    const info_message = resp['info_message'];
                    this.setState({ inputs: info_message });
                    this.setState({ titlepage: "Colis N° "+info_message.colis_barecode });
                    this.props.setCurrentPage('replymessagecolis-'+info_message.colis_barecode);
                    this.props.loaderDisplay(false);
                }
            })
           .catch(err => {
                this.props.loaderDisplay(false);
                this.props.openErrorSystem(true);
            })    
        }
         
    }

    render() {
        const inputs = this.state.inputs;
        const livreur = this.props.livreur;
        
        
        return (
            <React.Fragment>
                <div className="row mb-4 bg-template-opacity">
                    <div className="container py-4">
                        <div className="row">
                            <div className="col">
                                <h5 className="font-weight-normal template-primary">{this.state.titlepage}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div className="row">
                    <div className="container">
                        
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-header border-0 gradient-pink p-0">
                                <div className="row">
                                    <div className="col text-center py-4">
                                        <h3>Répondre au message <br/> <small> { inputs.message } </small></h3>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-10 col-xl-8 mx-auto">
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Écrivez votre réponse ici</label>
                                                <textarea name="replymessage" onChange={this.inputHandling}  className="form-control messagelivreur">
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button className="btn btn-info float-right" onClick={() => this.submit()}>Envoyer</button>
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

    inputHandling = (event) => {
        const target = event.target;
        const inputs = this.state.inputs;
        inputs[target.name] = target.value;
        this.setState({ inputs: inputs });
    }

}

export default withRouter(ReplyMessageLivreur);